export class FilterQueryRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filter",
            "baseName": "filter",
            "type": "Condition",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FilterQueryRequest.attributeTypeMap;
    }
    constructor() {
    }
}
